/*
 Created by CHT 2019/10/11 10:33
 */

import BaseItem from "../BaseItem"
import {
  DATA_TYPE__STRING,
  FORM_ITEM__SERIAL_NUMBER,
  PERMISSION__HIDDEN,
  PERMISSION__READ,
  SERIAL_NUM_CONFIG__DATE,
  SERIAL_NUM_CONFIG__FLIED,
  SERIAL_NUM_CONFIG__NUMBER,
  SERIAL_NUM_CONFIG__TEXT,
  SERIAL_NUM_DATE_FORMAT__YEAR,
  SERIAL_NUM_DATE_FORMAT__YEAR_MONTH,
  SERIAL_NUM_DATE_FORMAT__YEAR_MONTH_DAY,
  SERIAL_NUM_REPEAT_PERIOD__DAY,
  SERIAL_NUM_REPEAT_PERIOD__MONTH,
  SERIAL_NUM_REPEAT_PERIOD__NOT,
  SERIAL_NUM_REPEAT_PERIOD__WEEK,
  SERIAL_NUM_REPEAT_PERIOD__YEAR,
  SERIAL_NUM_TYPE__CUSTOM,
  SERIAL_NUM_TYPE__DEFAULT
} from "../types"
import {uuid} from "../utils"

class SerialNumber extends BaseItem {
  constructor() {
    super()
    this.value = ''
    // 编号格式 0 默认格式(1,2,3) 1 自定义格式 自定义格式 至少有自动计数信息
    this.serialNumType = 0
    this.serialNumConfig = [
      {
        id: uuid(),
        customTitle: "",  // 固定文字
        dateFormat: 1,   // 日期格式化类型 1 年 2 年月 3 年月日
        length: 5,       // 长度
        formId: null,     // 表单字段
        formTitle: "",                                 // 字段名称
        repeatPeriod: SERIAL_NUM_REPEAT_PERIOD__NOT,  // 属性：重置  值：(0 不重置 1 日 2 周 3 月 4 年)
        type: SERIAL_NUM_CONFIG__NUMBER               // 1 数字(不足用0填充 1)  2 提交日期 3 固定文本 4 表单字段
      }
    ]
  }

  get title() {
    return this.fieldTitle || SerialNumber._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }

}

SerialNumber._title = '流水号'
SerialNumber.type = FORM_ITEM__SERIAL_NUMBER
SerialNumber.use = true
SerialNumber.icon = 'iconfont icon-xinzengliushuihao'

SerialNumber.prototype.type = SerialNumber.type
SerialNumber.prototype.dataType = DATA_TYPE__STRING
SerialNumber.prototype.permissionOptional = [
  {
    value: PERMISSION__READ,
    label: '只读'
  },
  {
    value: PERMISSION__HIDDEN,
    label: '隐藏'
  }
]

SerialNumber.prototype.typeOptional = [
  {
    label: '系统默认',
    value: SERIAL_NUM_TYPE__DEFAULT
  },
  {
    label: '自定义',
    value: SERIAL_NUM_TYPE__CUSTOM
  }
]
SerialNumber.prototype.configTypeOptional = {
  [SERIAL_NUM_CONFIG__NUMBER]: {
    label: '自动计数',
    info: '根据位数和重复周期自动生成递增计数，例如：00005',
    value: SERIAL_NUM_CONFIG__NUMBER
  },
  [SERIAL_NUM_CONFIG__DATE]: {
    label: '提交日期',
    info: '将提交日期作为编号的组成部分',
    value: SERIAL_NUM_CONFIG__DATE,
  },
  [SERIAL_NUM_CONFIG__TEXT]: {
    label: '固定字符',
    info: '在编号中插入固定的自定义字符，支持中英文和特殊字符',
    value: SERIAL_NUM_CONFIG__TEXT,
  },
  [SERIAL_NUM_CONFIG__FLIED]: {
    label: '表单字段',
    info: '将表单内字段的值作为编号的组成部分',
    value: SERIAL_NUM_CONFIG__FLIED
  }
}
SerialNumber.prototype.repeatPeriodOptional = {
  [SERIAL_NUM_REPEAT_PERIOD__NOT]: {
    label: '不重置',
    value: SERIAL_NUM_REPEAT_PERIOD__NOT
  },
  [SERIAL_NUM_REPEAT_PERIOD__DAY]: {
    label: '每日重置',
    value: SERIAL_NUM_REPEAT_PERIOD__DAY
  },
  [SERIAL_NUM_REPEAT_PERIOD__WEEK]: {
    label: '每周重置',
    value: SERIAL_NUM_REPEAT_PERIOD__WEEK
  },
  [SERIAL_NUM_REPEAT_PERIOD__MONTH]: {
    label: '每月重置',
    value: SERIAL_NUM_REPEAT_PERIOD__MONTH
  },
  [SERIAL_NUM_REPEAT_PERIOD__YEAR]: {
    label: '每年重置',
    value: SERIAL_NUM_REPEAT_PERIOD__YEAR
  }
}
SerialNumber.prototype.dateTypeOptional = {
  [SERIAL_NUM_DATE_FORMAT__YEAR]: {
    label: '年',
    info: '预览：2019',
    value: SERIAL_NUM_DATE_FORMAT__YEAR
  },
  [SERIAL_NUM_DATE_FORMAT__YEAR_MONTH]: {
    label: '年月',
    info: '预览：201901',
    value: SERIAL_NUM_DATE_FORMAT__YEAR_MONTH
  },
  [SERIAL_NUM_DATE_FORMAT__YEAR_MONTH_DAY]: {
    label: '年月日',
    info: '预览：20190101',
    value: SERIAL_NUM_DATE_FORMAT__YEAR_MONTH_DAY
  }
}

SerialNumber.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
SerialNumber.prototype.getValue = function () {
  return this.value
}
SerialNumber.prototype.setValue = function (val) {
  this.value = val || ''
}
SerialNumber.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.serialNumConfig) {
    this.serialNumConfig = opts.serialNumConfig.map(serial => {
      serial.id = uuid()
      return serial
    })
  }
  if (opts.serialNumType) {
    this.serialNumType = opts.serialNumType
  }
}
SerialNumber.prototype.getConf = function () {
  const base = this.getBase()
  const serialNumConfig = this.serialNumConfig.map((serial, idx) => {
    delete serial.id
    serial.index = idx
    return serial
  })
  return {
    ...base,
    serialNumConfig,
    serialNumType: this.serialNumType,
  }
}
SerialNumber.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}
export default SerialNumber
